import { render, staticRenderFns } from "./AddResellerProductPage.vue?vue&type=template&id=509bdfb4"
import script from "./AddResellerProductPage.vue?vue&type=script&lang=js"
export * from "./AddResellerProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports